"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var trimEllipsify = function trimEllipsify(str, maxLength) {
  if (str.length > maxLength) {
    var words = str.slice(0, maxLength).split(" ");

    if (words.length > 1) {
      return "".concat(words.slice(0, -1).join(" "), " \u2026");
    } else {
      return "".concat(words[0].slice(0, -1), "\u2026");
    }
  }

  return str;
};

var _default = trimEllipsify;
exports["default"] = _default;